import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/VerifyCode.css';

const VerifyCode = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Get query params from URL
    const params = new URLSearchParams(location.search);
    const urlEmail = params.get('email');
    const urlCode = params.get('code');

    if (urlEmail) {
      setEmail(urlEmail);
      localStorage.setItem('resetEmail', urlEmail);
    } else {
      const storedEmail = localStorage.getItem('resetEmail');
      if (storedEmail) {
        setEmail(storedEmail);
      } else {
        setError('No email found. Please start the reset process again.');
        setTimeout(() => navigate('/forgot-password'), 3000);
        return;
      }
    }

    if (urlCode) {
      setCode(urlCode);
    }
  }, [location.search, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !code) {
      setError('Email and code are required.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://clinic123.onrender.com/api/auth/verify-reset-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code })
      });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('resetCode', code);
        navigate('/reset-password');
      } else {
        setError(data.error || 'Invalid code.');
      }
    } catch (err) {
      setError('Network error.');
    }
    setLoading(false);
  };

  return (
    <div className="verify-code-container">
      <div className="verify-code-box">
        <h2>Verify Code</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="code">Enter the code sent to your email</label>
            <input
              type="text"
              id="code"
              value={code}
              onChange={e => setCode(e.target.value)}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={loading} className="login-button">
            {loading ? 'Verifying...' : 'Verify Code'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyCode;
